import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../styles/AppTheme';
import { FormControl, Select, Input, MenuItem } from '@material-ui/core';
import { CustomSingleSelectDropDownStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';

export class SingleSelectDropDown extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <form key='form' autoComplete='off' className={css(Styles.form)}>
          <div className={css(Styles.innerContainer)}>
            {this.props.onSinglePickerFilter && this.props.singleSelectPicker &&
              <div className={css([Styles.searchContainer, Styles.singlePicker])}>
                <FormControl key='searchKeywords' margin='normal' fullWidth className={css(Styles.formControl)}>
                  {this.props.singleSelectPicker.title &&
                    <label className={css(Styles.label)}>{this.props.singleSelectPicker.title}</label>
                  }
                  <Select
                    onChange={this.props.onSinglePickerFilter}
                    value={this.props.singleSelectPicker.defaultValue}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                      },
                      getContentAnchorEl: null,
                      className: css(Styles.menuProps),
                      classes: {
                        paper: css(Styles.paperSelect)
                      }
                    }}
                    input={<Input disableUnderline={true} />}
                    inputProps={{
                      classes: {
                        root: css(Styles.textInputStyles, this.props.textInputStyles)
                      }
                    }}
                    disabled={this.props.disabled}
                    className={css(Styles.selectInput, this.props.inputContainer, this.props.disabled && Styles.disabledInput)}
                  >
                    {this.props.singleSelectPicker.options && this.props.singleSelectPicker.options.map((e, i) => (
                      <MenuItem key={'picker_option_' + i} value={e.key}>{e.value}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            }
          </div>
        </form>
      </div>
    )
  }

}

const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('SingleSelectDropDown')) ? CustomSingleSelectDropDownStyles : StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 16,
    maxWidth: AppTheme.viewPort,
  },
  selectInput: {
    minWidth: 150,
    padding: 10,
    paddingLeft: 22,
    border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: AppTheme.borderRadius,
    backgroundColor: 'white',
    height: '46px !important',
    '@media (max-width: 1024px)': {
      width: '100%',
      maxWidth: 'unset'
    },
  },
  formControl: {
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    },
    maxWidth: AppTheme.viewPort,
    width: '100%',
  },
  innerContainer: {
    display: 'flex',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  searchContainer: {
    flex: 1
  },
  menuProps: {
    zIndex: 130000,
    marginTop: 5
  },
  paper: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
    padding: '0px 10px'
  },
  textInputStyles: {
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16,
    margin: 0,
    ':focus': {
      backgroundColor: '#ffffff'
    }
  },
  singlePicker: {
    paddingRight: 10
  },
  paperSelect: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
    padding: '0px'
  }
})



// WEBPACK FOOTER //
// ./src/common/components/SingleSelectDropDown.js